import React from "react";
import { useTranslation } from "react-i18next";
import useHasAppSession from "../../hooks/useHasAppSession.js";
import useAnalyticsContext from "../../hooks/useAnalyticsContext.js";
import Button from "../common/Button";
import { trackCTA, trackLead } from "../../lib/analytics";

const Testimonial = () => {
  const { t } = useTranslation();
  const hasAppSession = useHasAppSession();
  const analyticsContext = useAnalyticsContext();

  const appBaseUrl = import.meta.env.VITE_APP_URL;
  // Mirrors the navbar CTA: signed-in browsers go to their dashboard, everyone
  // else to registration. The app's guards re-route a stale session to login,
  // so a wrong guess degrades gracefully.
  const ctaHref = hasAppSession
    ? `${appBaseUrl}/couple/dashboard`
    : `${appBaseUrl}/couple/create-event`;
  const ctaLabel = hasAppSession
    ? t("home.testimonial.ctaSignIn")
    : t("home.testimonial.ctaCreate");

  return (
    <section
      // data-w-id="4c9e72aa-224e-2766-fd92-6eb6c4a3525c"
      className="section home-testi"
    >
      <div className="container">
        <div className="quote-div">
          <div className="pad-15">
            <p className="made-36" style={{ paddingBottom: "16px" }}>
              {t("home.testimonial.heading")}
            </p>
            <p className="made-28">{t("home.testimonial.body")}</p>
          </div>
          <div className="vert-line _10vh mbm-exclusion"></div>
          <Button
            href={ctaHref}
            text={ctaLabel}
            target="_blank"
            className="button-lg"
            onClick={() => {
              // Signed-in visitors are heading to their dashboard (sign in);
              // everyone else is registering — only the latter is a lead.
              const ctaName = hasAppSession ? "sign_in" : "register";
              trackCTA("testimonial", { ...analyticsContext, ctaName });
              if (!hasAppSession) {
                trackLead("testimonial", { ...analyticsContext, ctaName });
              }
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
